import type { ScreenType } from '../../../types';
import { $gfFrame } from '@/app/index';
import { getElementGroup } from '../../Engine/useGemMeterStore';
import { WEAK_SENSE_OF_TRUST } from '../../../constants/rulesConstants';
import { checkEmptyDataSettings } from '../../Engine/useGemMeterHelper';

export default class WeakSenseOfTrustRule {
  static ruleId = WEAK_SENSE_OF_TRUST.id;

  static validate(screenType: ScreenType, removeElementId?: string) {
    const $productElement = $gfFrame().contents().find(`.module-wrap[data-key=product]`);
    if ($productElement.length === 0) {
      return true;
    }

    const elementGroups = getElementGroup() || {};
    const elementGroupByRuleId = elementGroups[screenType][WEAK_SENSE_OF_TRUST.id] || {};
    const isPageEmpty = checkEmptyDataSettings(removeElementId);

    return Object.keys(elementGroupByRuleId).length > 0 || isPageEmpty;
  }
}
